import type { ListData, CastData, SectionStatus } from '../../types/canvas';
import { StatusDot } from './StatusDot';
import { ActionBar } from './ActionBar';

interface ListCardProps {
  title: string;
  data: ListData | CastData;
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function ListCard({ title, data, status, onApprove, onRefine, onAnother, refineDisabled }: ListCardProps) {
  const items = data.type === 'list'
    ? data.items.map((i) => ({ name: i.name, detail: i.detail }))
    : data.characters.map((c) => ({ name: c.name, detail: `${c.role} — ${c.description}` }));

  return (
    <div className="bg-surface border border-border rounded-lg p-[18px] sm:px-[22px]">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-[15px] font-semibold text-foreground">{title}</span>
        <span className="text-[10px] font-semibold py-0.5 px-2 rounded-full bg-background border border-border text-muted-foreground">
          {items.length}
        </span>
        <div className="ml-auto"><StatusDot status={status} /></div>
      </div>
      <ul className="list-none">
        {items.map((item, i) => (
          <li key={i} className="py-2 border-b border-border last:border-b-0 flex items-baseline gap-2 text-sm">
            <span className="font-medium text-foreground">{item.name}</span>
            <span className="font-display italic text-[13px] text-muted-foreground [font-variation-settings:'opsz'_48,'SOFT'_80]">
              {item.detail}
            </span>
            <span className="text-placeholder ml-auto text-xs">&#x203A;</span>
          </li>
        ))}
      </ul>
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
